const fundingReducers = {
  userGetFundingAccountsSuccess: (
    userStore,
    payload: { pendingVerification: any[] }
  ) => ({
    ...userStore,
    fundingAccounts: payload.pendingVerification[0]
  }),

  userGetBankNameLoading: userStore => ({
    ...userStore,
    bankName: ''
  }),

  userGetBankNameSuccess: (userStore, payload) => ({
    ...userStore,
    bankName: payload.name
  }),

  userGetBankNameFailure: userStore => ({
    ...userStore,
    bankName: null
  }),

  setFunding: (userStore, { funding }: { funding: string }) => ({
    ...userStore,
    funding
  })
};

export default fundingReducers;
